<template>
  <div class="page">
    <router-view />
  </div>
</template>

<style lang="scss" scoped>

</style>
